import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@ls/react-tooltip';
import styled from 'styled-components';
import Ripple from './Ripple';
import Spinner from './Spinner';

const ButtonContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const ButtonComp = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 3px;
  cursor: pointer;
  overflow: hidden;
  border: 1px solid ${({variation}) => {
    switch (variation) {
      case 0:
      case 1:
        return '#a7a7a7';
      case 4:
        return '#FFFFFF';
      default:
        return 'transparent';
    }
  }};
  background: ${({theme, variation}) => {
    switch (variation) {
      case 0:
      case 1:
      case 4:
      case 5:
      case 6:
        return 'none';
      case 2:
        return theme.accentColor;
      case 3:
      default:
        return theme.primaryColor
    }
  }};
  ${({size}) => {
    switch (size) {
      default:
      case 'M':
        return `
          min-height: 30px;
          padding: 0 10px;
        `;
      case 'S':
        return `
          min-height: 10px;
          padding: 0 1px;
        `;
    }
  }}
  &:disabled {
    filter: contrast(0.1);
    cursor: unset;
    pointer-events: all;
  }
  &:hover:not(:disabled){
    filter: brightness(1.3);
  }
`;

export const Label = styled.div`
  color: ${({variation, theme}) => {
    switch (variation) {
      case 1:
        return theme.textColorDark;
      case 2:
      case 3:
      case 4:
      case 5:
        return theme.textColorLight;
      case 0:
      case 6:
        return theme.primaryColor;
    }
  }};
`;

export const Icon = styled.div`
  color: ${({theme, variation}) => {
    switch (variation) {
      case 1:
        return theme.textColorDark;
      case 2:
      case 3:
      case 4:
      case 5:
        return theme.textColorLight;
      case 0:
      case 6:
        return theme.primaryColor;
    }
  }};
  ${({hasLabel}) => hasLabel ? 'margin: 0 5px 0 0' : ''};
`;

export const Button = (props) => {
  const {size, disabled, loading, raise, label, icon, tooltip, onButtonClick, onClick, variation, className} = props;
  return (
    <ButtonContainer className={className}>
      <Tooltip label={tooltip}>
        <ButtonComp
          disabled={disabled || loading}
          variation={variation}
          size={size}
          raise={raise}
          onClick={disabled || loading ? undefined : (onClick || onButtonClick)}
        >
          {!disabled && <Ripple/>}
          {icon && (
            <Icon hasLabel={!!label} variation={variation}>{icon}</Icon>
          )}
          {label && (
            <Label variation={variation}>
              {label}
            </Label>
          )}
        </ButtonComp>
      </Tooltip>
      {loading && <Spinner size={size} variation={variation}/>}
    </ButtonContainer>
  );
}

Button.propTypes = {
  variation: PropTypes.number,
  size: PropTypes.oneOf(['S', 'M']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  label: PropTypes.node,
  icon: PropTypes.node,
  tooltip: PropTypes.node,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  variation: 0,
  size: 'M',
  disabled: false,
  loading: false,
  label: undefined,
  icon: undefined,
  tooltip: undefined,
};

export default Button;
